export default {
  path: '/settlements',
  name: 'settlements',
  component: () => import('../components/Layout'),
  children: [
    {
      name: 'SettlementShow',
      path: ':id',
      component: () => import('../views/settlement/Show')
    },
    {
      name: 'SettlementCreate',
      path: 'create/:account_id',
      component: () => import('../views/settlement/Create')
    }
  ]
}
